import { render } from "./NavMenu.vue?vue&type=template&id=70e15c19"
import script from "./NavMenu.vue?vue&type=script&lang=ts"
export * from "./NavMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script